import React, { Component } from "react";
import TransferInterbancaService from "../../../../services/transferencias/TransferInterbancaService";
import Popup from "react-popup";

import $ from "jquery";
import CuentaExternaService from "../../../../services/transferencias/CuentaExternaService";
import TransferCuentasTercerosService from "../../../../services/transferencias/TransferCuentasTercerosService";
import { trackPromise } from "react-promise-tracker";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faClose, faSave} from "@fortawesome/free-solid-svg-icons";

export default class PopupAgregarCuentaTercero extends Component {

  constructor(props) {
    super(props);
    this.guardar = this.guardar.bind(this);
    this.validate = this.validate.bind(this);
    this.initData();
  }

  componentDidMount() {

  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  initData() {
    this.state = this.getInitialState();
  }

  getInitialState = () => {

    $("#inputNroCuenta").val("");

    return {
      entidadNew: "",
      nroCuentaNew: "",
      nombreApellidoNew: "",
      tipoDocNew: "",
      documentoNew: "",
      btnGuardarEnabled: false
    }

  };

  /*
  guardar() {
    TransferInterbancaService.addCuentaExterna(
      this.state.nombreApellidoNew,
      this.state.nroCuentaNew,
      this.state.tipoDocNew,
      this.state.documentoNew,
      this.state.entidadNew
    )
      .then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);
        if (jData.codigo === 0) {
          this.setState(this.getInitialState());
          this.modalCuenta.click();
          this.props.addCuentaCallback("OK");
        } else {
          Popup.queue(this.notifiPopup("Error", jData.mensaje));
          this.props.addCuentaCallback("FAIL");
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }
*/

  verificarCuenta(cuentaDestino) {

    trackPromise(
      TransferCuentasTercerosService.validarCuenta(cuentaDestino)
        .then((response) => {

          var data = response.data;

          //console.log(data);

          if (data.codigo !== 0) {
            Popup.queue(this.notifiPopup("Info", data.mensaje));
            this.setState(this.getInitialState());
            return null;
          }

          let datosSocio = data.datos;

          
          this.setState({
            ...this.state,
            nroCuentaNew: cuentaDestino,
            nombreApellidoNew: datosSocio.nombreSocio,
            tipoDocNew: datosSocio.tipoDocumento.id,
            documentoNew: datosSocio.documento,
            entidadNew: datosSocio.entidad.id,
            btnGuardarEnabled: true
          });

        })
        .catch(error => {
          console.log(error);
          Popup.queue(
            this.notifiPopup(
              "Info",
              "Error Inesperado. Intenta volver a recargar esta página o no dudes en contactar con nosotros si el problema persiste."
            )
          );
          this.setState(this.getInitialState());
        })
    )

  }

  handleBtnBuscar() {
    let nroCuenta = $("#inputNroCuenta").val();
    if (nroCuenta) this.verificarCuenta(nroCuenta);
  }

  guardar() {

    trackPromise(

      CuentaExternaService.addCuentaExterna(
        this.state.nombreApellidoNew,
        this.state.nroCuentaNew,
        this.state.tipoDocNew,
        this.state.documentoNew,
        this.state.entidadNew,
        "CU"
      )
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jData = JSON.parse(data);
          if (jData.codigo === 0) {
            this.modalCuenta.click();
            this.props.addCuentaCallback({
              response: "OK",
              data: this.state.nroCuentaNew
            });
            this.setState(this.getInitialState());
          } else {
            Popup.queue(this.notifiPopup("Error", jData.mensaje));
            this.props.addCuentaCallback({
              response: "FAIL"
            });
          }
        })
        .catch(error => {
          console.log("error")
          console.log(error);
          this.setState(this.getInitialState());
          Popup.queue(this.notifiPopup("Error", "Error Inesperado, por favor intente nuevamente"));
          this.props.addCuentaCallback({
            response: "FAIL"
          });
        })
    )

  }

  validate = (e) => {
    $.validator.addMethod("dataType", (value, element) => {
      if (
        this.state.tipoDocNew === "3" &&
        isNaN(Number(this.state.documentoNew))
      ) {
        return false;
      }

      return true;
    });

    $("#idFormAddCuenta").validate({
      submitHandler: () => {
        this.guardar();
      },
      rules: {
        entidadNew: {
          required: true,
        },
        nroCuentaNew: {
          required: true,
        },
        nombreApellidoNew: {
          required: true,
        },
        tipoDocNew: {
          required: true,
        },
        documentoNew: {
          required: true,
          dataType: { dataType: true },
        },
      },
      messages: {
        entidadNew: {
          required: "Este campo es requerido",
        },
        nroCuentaNew: {
          required: "Este campo es requerido",
          number: "Favor ingrese un número válido, sin guión ni caracteres especiales",
        },
        nombreApellidoNew: {
          required: "Este campo es requerido",
        },
        tipoDocNew: {
          required: "Este campo es requerido",
        },
        documentoNew: {
          required: "Este campo es requerido",
          dataType: "Sólo números para Cédula de Identidad",
        },
      },
      errorElement: "span",
      errorPlacement: function (error, element) {
        error.addClass("invalid-feedback");
        element.closest(".form-group").append(error);
      },
      highlight: function (element, errorClass, validClass) {
        $(element).addClass("is-invalid");
      },
      unhighlight: function (element, errorClass, validClass) {
        $(element).removeClass("is-invalid");
      },
    });
  };

  render() {

    const listItems = this.props.items.map((item) => (
      <option key={item.id} value={item.id}>
        {item.nombre}
      </option>
    ));

    listItems.unshift(
      <option key="-1" value="" disabled>
        -- Seleccione--
      </option>
    );

    const listTiposDocumentos = this.props.tipos.map((elemento) => (
      <option key={elemento.id} value={elemento.id}>
        {elemento.descripcion}
      </option>
    ));

    listTiposDocumentos.unshift(
      <option key="-1" value="" disabled>
        -- Seleccione--
      </option>
    );

    return (
      <form
        id="idFormAddCuenta"
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <div
          className="modal fade"
          id="modal-cuenta"
          data-backdrop="false"
        >
          <div className="modal-dialog  modal-dialog-centered  modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Datos de la Cuenta</h5>
              </div>
              <div className="modal-body">
              <div className="col-lg-9 col-md-9">
                  <label className="input-label">Nro. de Cuenta</label>
                  </div>
                <div className="row">
                  
                  <div className="col-lg-9 col-md-9">
                  
                    <div className="form-group">
                      
                      <input
                        placeholder="Ingresar sin guiones (-) o barras (/)"
                        name="nroCuentaNew"
                        id="inputNroCuenta"
                        //value={""}
                        type="number"
                        className="input-box form-control"
                      />
                    </div>
                    
                  </div>
                  <div className="col-lg-3 col-md-3">
                  <div className="form-group">
                      <button type="button" className="btn btn-cu-secundary" onClick={() => { this.handleBtnBuscar() }} style={{width:"100%"}}>
                        <i className="fa fa-search" /> Buscar
                      </button>
                    </div>
                    </div>
                  <div className="col-12">
                    <div className="form-group">
                      <label className="input-label">Nombre y Apellido</label>
                      <input
                        name="nombreApellidoNew"
                        disabled
                        value={this.state.nombreApellidoNew}
                        type="text"
                        className="input-box form-control"
                        onChange={(val) => {
                          this.setState({
                            nombreApellidoNew: val.target.value.toUpperCase(),
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <label className="input-label">Tipo de Documento</label>
                      <select
                        name="tipoDocNew"
                        disabled
                        value={this.state.tipoDocNew}
                        className="form-control input-box"
                        style={{ width: "100%" }}
                        onChange={(val) => {
                          this.setState({ tipoDocNew: val.target.value });
                        }}
                      >
                        {listTiposDocumentos}
                      </select>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <label className="input-label">Documento</label>
                      <input
                        name="documentoNew"
                        value={this.state.documentoNew}
                        disabled
                        type="text"
                        className="input-box form-control"
                        onChange={(val) => {
                          this.setState({ documentoNew: val.target.value });
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <div className="col-md-12">
                  <div className="row">
                    <div className="col-md-6 btn-consulta">
                    <button
                  type="button"
                  className="btn btn-cu-quintary"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    $("#idFormAddCuenta").validate().resetForm();
                    this.setState(this.getInitialState());
                  }}
                >
                <FontAwesomeIcon icon={faClose} />  Cerrar
                </button>
                    </div>
                    <div className="col-md-6">
                    <button
                  className="btn btn-cu-primary"
                  disabled={!this.state.btnGuardarEnabled}
                  onClick={() => {
                    this.validate();
                  }}
                >
                <FontAwesomeIcon icon={faSave} />  Guardar
                </button>
                    </div>
                  </div>
                </div>
                
               
              </div>
            </div>
            {/* /.modal-content */}
          </div>
          {/* /.modal-dialog */}
          <a
            data-controls-modal="modal-cuenta"
            ref={(a) => (this.modalCuenta = a)}
            data-backdrop="false"
            href="#"
            hidden
            id="showModalCuenta"
            data-toggle="modal"
            data-target={"#modal-cuenta"}
          ></a>
        </div>
      </form>
    );
  }
}
